import React from "react";
import AuthService from "../services/AuthService";
import {Redirect, Route} from "react-router-dom";

function RouteProtected(props) {
  return AuthService.isSigned() ? <Route path={props.path}>{props.children}</Route> : <Redirect push to="/"/>;
}

export default RouteProtected;
